<template lang='pug'>
//- 會員驗證信箱
div(:class='$style[`cc-popbox-sendVerify`]')
  .popbox-close
    button.popbox-close-btn(
      aria-label='關閉'
      tabindex='0'
      @click='handleClosePopBox')

  div(:class='$style[`cc-content-new`]')
    div(:class='$style[`cc-content-title`]')
      span.font-bold(:class='$style[`cc-banner-main-title`]')
        span.no-wrap 接收
        span.font-doctor-theme 驗
        span.font-normal-theme 證
        span.no-wrap 的信箱
      div(:class='$style[`cc-content-title-tips`]') * 請確認信箱是有效的，避免收不到驗證信。

    Inputer(
      title='接收驗證信的信箱'
      v-model.trim='formConfig.status.accountValue'
      :defaultValue='loginStatus ? loginProfile.email : ``'
      :class='$style[`cc-content-new-input`]'
      :resetButton='false'
      :placeholder='`接收驗證信的信箱`'
      :beforeIcon='`mail`'
      :beforeIconSize='24'
      :beforeIconColor='`#d0d0d0`'
      :type='`email`'
      :errorRegex='formConfig.verify.accountRegexError'
      :errorRegexInfo='formConfig.verify.accountErrorLog'
      :errorValue='formConfig.verify.accountError'
      :keyPressEnter='handleCheckProgressBeforeLogin'
      @clearErrorMsg="(value) => {this.formConfig.verify.accountError = value[0]; this.formConfig.verify.accountRegexError = value[1]; this.showErrorMsg = false;}")

    button(
      title='送出'
      tabindex='0'
      aria-label='送出'
      :disabled='showLoading'
      :class='[$style[`cc-content-new-send`], $style[!this.formConfig.status.accountValue ? `cc-content-disabled` : ``]]'
      @click='handleCheckProgressBeforeLogin')
      IconLoading(v-if='showLoading' :size='18' :color='`#fff`')
      span {{ showLoading ? `` : `送出`}}

    div(v-if='showErrorMsg' :class='$style[`cc-content-error`]') 查無此帳號或信箱

</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

import Inputer from '../common/Input';
import IconLoading from '../../icon/Loading';

import {
  putSendVerifiedMail,
} from '../../../js/restapi';

export default {
  components: {
    Inputer,
    IconLoading,
  },

  data() {
    return {
      showLoading: false,
      formAccountType: '',

      formConfig: {
        status: {
          accountValue: '',
        },
        verify: {
          accountRegexError: false,
          accountErrorLog: '',
          accountError: false,
        },
        verifyAllPass: true,
      },
      showErrorMsg: false,
    };
  },

  created() {
    this.showErrorMsg = this.$options.data().showErrorMsg;
    if (this.loginStatus && this.loginProfile.email) {
      this.formConfig.status.accountValue = this.loginProfile.email;
    }
  },

  methods: {
    ...mapMutations({
      changePopBoxStatus: 'global/POPBOX_STATUS',
    }),

    handleClosePopBox() {
      this.changePopBoxStatus({
        active: false,
        include: '',
      });
    },

    handleFormsCheckToPass() {
      this.formConfig.verifyAllPass = this.$options.data().formConfig.verifyAllPass;
      const emailPattern = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
      // const phonePattern = new RegExp(/^09\d{8}$/);

      if (this.formConfig.status.accountValue) {
        // 信箱格式有誤
        if (this.formConfig.status.accountValue.match(emailPattern)) {
          this.formAccountType = 'email';
        } else {
          this.formConfig.verify.accountRegexError = true;
          this.formConfig.verify.accountError = true;
          this.formConfig.verify.accountErrorLog = '格式錯誤(範例: mail@cancell.ai)';
          this.formConfig.verifyAllPass = false;
        }
      } else {
        // 信箱為空
        this.formConfig.verify.accountError = true;
        this.formConfig.verifyAllPass = false;
      }
    },

    processAfterResetSuccess() {
      this.showLoading = false;

      this.changePopBoxStatus({
        active: true,
        include: 'sendConfirm',
      });

      setTimeout(() => {
        this.handleClosePopBox();
      }, this.POP_DURATION);
    },

    handleConnectDjangoWithApi() {
      // IF Verify On Error, Return
      if (!this.formConfig.verifyAllPass) { return; }
      this.showLoading = true;

      putSendVerifiedMail('', {
        mail: this.formConfig.status.accountValue,
        hashcode: this.loginHashCode,
        oauth: this.loginProfile.oauth,
        usertype: this.loginProfile.user_type,
      }, {
        headers: {
          'content-Type': 'application/json',
          // Authorization: `Bearer ${jwtAccess}`,
        },
      })
        .then((/* response */) => {
          // console.log(response.data.results);
          this.processAfterResetSuccess();
        })
        .catch((error) => {
          console.log('Axios putSendVerifiedMail Error', error.response);
          if (error.response.status === 401) {
            this.changePopBoxStatus({
              active: true,
              include: 'relogin',
            });
          }
        });

      // // (查詢密碼 Auth Step-1) 確認有無Email帳號
      // putDjangoAllTypeMember(`?oauth=${this.formConfig.status.accountValue}`)
      //   .then((response) => {
      //     // console.log(response.data);
      //     const getResult = response.data;
      //     if (getResult.count !== 0) {
      //       console.log('查詢密碼 Auth Step-1:: 核對有無Email帳號，Pass!');

      //       if (this.formAccountType === 'email') {
      //         const userType = response.data.results[0].user_type;
      //         this.processAfterResetSuccess(userType);
      //       } else {
      //         this.showLoading = false;
      //       }

      //     } else {
      //       console.log('查詢密碼 Auth Step-1:: 核對有無Email帳號，Failed!');
      //       this.showLoading = false;
      //       this.showErrorMsg = true;
      //     }
      //   })
      //   .catch((/* error */) => {
      //     this.showLoading = false;
      //   });
    },

    async handleCheckProgressBeforeLogin() {
      await this.handleFormsCheckToPass();
      await this.handleConnectDjangoWithApi();
    },
  },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      // authJwtToken: 'user/exportUserJwtToken',
      loginHashCode: 'user/exportUserHashCode',
      loginStatus: 'user/exportLoginStatus',
      loginProfile: 'user/exportUserProfile',
    }),
  },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/popbox/popSendVerify.scss';
</style>
